import React, { createContext, PropsWithChildren, useCallback } from 'react'
import { ICollectionLineConfig, ICollectionLineEntry } from '../../components/categorypage/categorypage.d'

// The key is the Collection Line ID, as received from BSITE/PCS via Backend


export const CollectionLineContext =
    createContext<{ getCollectionConfigById: (id: string) => ICollectionLineEntry | undefined }>(
        {
            getCollectionConfigById: () => undefined
        }
    )

const CollectionLineContextProvider: React.FC<PropsWithChildren<{ collectionMappings: ICollectionLineConfig }>>
    = ({ collectionMappings, children }) => {
        const getCollectionConfigById = useCallback(
            (id: string | number) => collectionMappings ? collectionMappings[`${id}`] : undefined,
            [collectionMappings]
        )

        return (
            <CollectionLineContext.Provider value={{ getCollectionConfigById }}>
                {children}</CollectionLineContext.Provider>
        )
    }

export default CollectionLineContextProvider